/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsTournamentidTeamStatsReplaysQueryResponse,
  GetTournamentsTournamentidTeamStatsReplaysPathParams,
} from "../types/GetTournamentsTournamentidTeamStatsReplays.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsTournamentidTeamStatsReplaysQueryKey = (
  tournamentId:
    | GetTournamentsTournamentidTeamStatsReplaysPathParams["tournamentId"]
    | undefined,
) =>
  [
    {
      url: "/tournaments/:tournamentId/team-stats/replays",
      params: { tournamentId: tournamentId },
    },
  ] as const;

export type GetTournamentsTournamentidTeamStatsReplaysQueryKey = ReturnType<
  typeof getTournamentsTournamentidTeamStatsReplaysQueryKey
>;

/**
 * @summary KAN-790: командная статистика за все игры турнира — по строке на команду.
 * Пустой список означает, что реплеев в турнире нет; это штатное состояние.
 * {@link /tournaments/:tournamentId/team-stats/replays}
 */
export async function getTournamentsTournamentidTeamStatsReplays(
  tournamentId: GetTournamentsTournamentidTeamStatsReplaysPathParams["tournamentId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsTournamentidTeamStatsReplaysQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/tournaments/${tournamentId}/team-stats/replays`,
    ...requestConfig,
  });
  return res;
}

export function getTournamentsTournamentidTeamStatsReplaysQueryOptions(
  tournamentId:
    | GetTournamentsTournamentidTeamStatsReplaysPathParams["tournamentId"]
    | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey =
    getTournamentsTournamentidTeamStatsReplaysQueryKey(tournamentId);
  return queryOptions<
    ResponseConfig<GetTournamentsTournamentidTeamStatsReplaysQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetTournamentsTournamentidTeamStatsReplaysQueryResponse>,
    typeof queryKey
  >({
    enabled: !!tournamentId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournamentsTournamentidTeamStatsReplays(tournamentId!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary KAN-790: командная статистика за все игры турнира — по строке на команду.
 * Пустой список означает, что реплеев в турнире нет; это штатное состояние.
 * {@link /tournaments/:tournamentId/team-stats/replays}
 */
export function useGetTournamentsTournamentidTeamStatsReplays<
  TData =
    ResponseConfig<GetTournamentsTournamentidTeamStatsReplaysQueryResponse>,
  TQueryData =
    ResponseConfig<GetTournamentsTournamentidTeamStatsReplaysQueryResponse>,
  TQueryKey extends QueryKey =
    GetTournamentsTournamentidTeamStatsReplaysQueryKey,
>(
  tournamentId:
    | GetTournamentsTournamentidTeamStatsReplaysPathParams["tournamentId"]
    | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsTournamentidTeamStatsReplaysQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getTournamentsTournamentidTeamStatsReplaysQueryKey(tournamentId);

  const query = useQuery(
    {
      ...getTournamentsTournamentidTeamStatsReplaysQueryOptions(
        tournamentId,
        config,
      ),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
